import apiClient from './apiClient';

/**
 * Checkout Template Service
 *
 * API calls for managing checkout template definitions.
 * Uses path-based multi-tenancy: /api/orgs/{orgId}/checkout-templates
 *
 * Pagination contract matches other listing APIs:
 *   limit (1..200, default 50), offset (>=0, default 0),
 *   q (free-text search), sortBy + sortOrder (asc|desc).
 */
const checkoutTemplateService = {
  /**
   * List / search checkout templates for an organization.
   * @param {number} orgId
   * @param {{ q?: string, limit?: number, offset?: number,
   *           sortBy?: string, sortOrder?: 'asc'|'desc' }} [opts]
   */
  listTemplates: async (orgId, opts = {}) => {
    const params = {};
    if (opts.q          != null && opts.q !== '') params.q        = opts.q;
    if (opts.limit      != null) params.limit     = opts.limit;
    if (opts.offset     != null) params.offset    = opts.offset;
    if (opts.sortBy     != null) params.sortBy    = opts.sortBy;
    if (opts.sortOrder  != null) params.sortOrder = opts.sortOrder;
    const response = await apiClient.get(`/api/orgs/${orgId}/checkout-templates`, { params });
    return response.data;
  },

  createTemplate: async (orgId, payload) => {
    const response = await apiClient.post(`/api/orgs/${orgId}/checkout-templates`, payload);
    return response.data;
  },

  updateTemplate: async (orgId, templateId, payload) => {
    const response = await apiClient.patch(`/api/orgs/${orgId}/checkout-templates/${templateId}`, payload);
    return response.data;
  },

  deleteTemplate: async (orgId, templateId) => {
    await apiClient.delete(`/api/orgs/${orgId}/checkout-templates/${templateId}`);
  },
};

export default checkoutTemplateService;

